import styled, {css} from 'styled-components';

export const GalleryWrapper = styled.div`
  background: ${({color}) => color};
  padding: 3rem 0;
`;

export const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-gap: 1rem;
  ${({columnsNumber}) =>
    columnsNumber &&
    css`
      grid-template-columns: repeat(${columnsNumber}, 1fr);
      grid-gap: 1rem;
      grid-template-rows: auto;
    `};
  ${({isFlex}) =>
    isFlex &&
    css`
      display: flex;
      gap: 1rem;
      justify-content: center;
    `};
  @media (max-width: 1024px) {
    max-width: 100% !important;
    grid-template-columns: repeat(2, 1fr);
    ${({isFlex}) =>
      isFlex &&
      css`
        align-items: center;
        flex-direction: column;
      `};
  }
`;

export const Figure = styled.figure`
  width: 100%;
  height: 100%;
  overflow: hidden;
  cursor: pointer;
  box-shadow: ${({hoverColor}) =>
    hoverColor ? '' : '0 0 10px 2px rgba(0, 0, 0, 0.25)'};
  position: relative;

  ${({hoverColor}) =>
    hoverColor
      ? css`
          &:hover {
            &::after {
              content: '';
              width: 100%;
              height: 100%;
              background-color: ${hoverColor};
              position: absolute;
              top: -5px;
              left: 0;
            }
          }
        `
      : css`
          &:hover img {
            transform: scale(1.15);
          }
        `};

  .special-image {
    width: 100%;
    height: 100%;
    transform: scale(1);
    transition: 0.3s ease-in-out;
  }

  .special-image-cover {
    width: 100%;
    height: 100%;
    transform: scale(1);
    transition: 0.3s ease-in-out;
    object-fit: cover;
  }
  span {
    height: 100%;
  }
`;

export const GalleryPic = styled.img``;

// GallerySlider

export const Modal = styled.div`
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ExitButton = styled.img`
  position: absolute;
  top: 0;
  right: -10%;
  width: 1.5rem;
  cursor: pointer;
`;

export const DownloadLink = styled.a`
  display: block;
  position: absolute;
  bottom: 0;
  right: -10%;
  cursor: pointer;
`;

export const DownloadButton = styled.img`
  width: 1.5rem;
`;

export const Arrow = styled.img`
  width: 1.5rem;
  height: 1.5rem;
  &::before {
    font-size: 1.5rem;
  }
  &.slick-next {
    right: -3rem;
  }
  &.slick-prev {
    left: -3rem;
  }
`;

export const SliderWrapper = styled.div`
  width: 65%;
  position: relative;
  /* max-height: 70%; */

  @media (max-width: 1024px) {
    width: 75%;
  }
`;

export const SliderImg = styled.img`
  max-width: 60vw;
  max-height: 80vh;
  /* max-height: 100%; */
`;

export const PhotoSign = styled.p`
  color: ${({color}) => color || '#525252'};
  font-family: 'LATOREGULAR';
  font-size: 0.65rem;
  font-weight: 400;
  font-style: normal;
  letter-spacing: normal;
  line-height: normal;
  text-align: center;
  margin-top: 1rem;

  @media (max-width: 768px) {
    padding-bottom: 1rem;
  }
`;

export const CenterSlide = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  position: relative;
`;

export const SliderSign = styled.p`
  margin: 1rem 0;
  text-align: center;
  color: white;
  font-family: 'LATOREGULAR';
  font-size: 0.65rem;
  font-weight: 400;
  font-style: normal;
  letter-spacing: normal;
  line-height: normal;
  text-align: center;
`;
